import app from '../app.first';
import $ from 'jquery';
import Cookies from 'js-cookie';

app.AdminMain = class extends app.Component {
	//this function runs on every single page, so call functions from this function that you need to run on every page
	constructor($this) {
		super($this);
		this.onLoad();
		$(() => this.onDocumentReady($this));
	}

	onLoad() {

	}

	onDocumentReady($this) {
        // if there is a form field, make sure that if empty spaces, it's trimmed. We do this so that abide still validates.
		// is it right to run this on every page? Probably ok, quite lightweight. Other option to run only on pages it needs running.
		$('input').blur(function() {
			this.value=$(this).val().trim();
		 });

		 $("a[href='#top']").click(function() {
			$("html, body").animate({ scrollTop: 0 }, "fast");
			return false;
		 });

		// MULTI SELECT, USING SELECT 2
		if($(".select2").length) {
			$(".select2").select2({ width: '100%' });
		}
		// In case you want a multiple select to not close on select of an option, give it the class select_2_multiple
		if($(".select2_multiple").length) {
			$(".select2_multiple").select2({ width: '100%', closeOnSelect: false });
		}

		// WYSIWYG
		if($(".redactor").length) {
			$R('.redactor', {
				plugins: ['limiter', 'alignment', 'fullscreen', 'source', 'table', 'video'],
				imageUpload: '/ajax/redactor-upload.json',
				imageResizable: true,
				imagePosition: true,
				callbacks: {
					upload: {
						beforeSend: function(xhr)	{
							var token = Cookies.get('csrfToken');
							if(token) {
								xhr.setRequestHeader('X-CSRF-Token', token);
							}
						}
					}
				}
			});
		}

		// MODAL CUSTOM
		// open a modal on page load if it has the .open class
		$('[data-reveal]').each(function(index, element){
			if ($(this).hasClass('open')) {
				$(this).foundation('open');
			}
		});

		//	IMAGE UPLOADING
		// only add  and the code below if we have a slim upload field on the form
		if($(".slim").length) {
			slimValidation();
		}

		// DATE PICKER
		// only add  if we have a date picker. @todo put  into the main JS function? should be generic throughout the project?
		if($(".pika-day").length) {
			setDatePickers();
		}

		function setDatePickers() {
			var picker = [];
			$('.pika-day').each(function(index, element) {

				var field_type = $(this).data("field-type");
				let show_time = false;
				let date_format = 'YYYY-MM-DD';
				if (field_type == 'datetime') {
					show_time = true;
					date_format = 'YYYY-MM-DD HH:mm:ss';
				}

				picker[index] = new Pikaday({
					field: element,
					format: date_format,
					use24hour: false,
					showTime: show_time
				});
			});
		}

		function slimValidation() {
			$(document).on('click', '#btnFrmSubmit', function(e) {

				$(document).on("forminvalid.zf.abide", function(ev,frm) {
					e.preventDefault(); //prevent the default action
					// check if we have a image

					let have_error = false;
					$('.slim_wrapper').each(function(index, element) {
						var slim_form_field_id = $(this).data("slim-form-field-id");
						var slim_field_wrapper_id = $(this).data("slim-field-wrapper-id");
						var slim_required = $(this).data("slim-is-required");

						if(!slim_required) {
							return true; // continue loop
						}

						let image = $("#" + slim_form_field_id);
						let slim_wrapper = $("#" + slim_field_wrapper_id);

						if(!image.val()) {
							slim_wrapper.addClass('slim-error');
							var scrollToSlim = slim_wrapper.offset().top - 25;
							$('html, body').animate({
							  scrollTop: scrollToSlim
							}, 400);
							have_error = true;
							return false; //break loop
						}
					});

					if(have_error) {
						return false;
					}

					var invalidFields = $(this).find('[data-invalid]');

					// scroll to first invalid field
					if (invalidFields) {
						// - xx so that the label shows.
						var scrollTo = $('#'+invalidFields[0].id).offset().top - 25;
						$('html, body').animate({
						  scrollTop: scrollTo
						}, 400);
						return false;
					}
					return false;
				});


				$(document).on("formvalid.zf.abide", function(ev,frm) {
					$( "#btnFrmSubmit" )[0].submit(); // if we don't have the [0] it submits like a billion times. No idea why
				});

			});
		}
	}

}
